// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"checkbox___LB7sf"};